import { TokenService } from '@processo/services/token.service';
import { AuthService } from '../authentication/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

export function appInitializer(
  tokenService: TokenService,
  authService: AuthService,
  router:Router
) {
  const refresh_token: any = localStorage.getItem('refresh_token');
  const urlParams = new URLSearchParams(window.location.search);
  const form_id = urlParams.get('form_id');
  if (form_id) {
    localStorage.removeItem('refresh_token');
    return () => Promise.resolve(true);
  }
  return () =>
    new Promise((resolve: any) => {
      if (
        refresh_token &&
        refresh_token != '' &&
        refresh_token != 'undefined'
      ) {
        authService.updateToken().subscribe(()=>{
          resolve(true);
        },()=>{
          resolve('foo');
        });

      } else {
        setTimeout(() => {
          resolve('foo');
        }, 300);
      }
    }).then((resp)=>{
      if (resp == true) {
        const noRedirectPaths = ['/login', '/contact-us', '/register', '/registernew', '/forgot-password', '/registernew/additional-details','/registernew/verify-account'];

        const currentPath = `${window.location.pathname}${window.location.search}`;

        if (currentPath !== '/loading' && !noRedirectPaths.includes(currentPath)) {
          router.navigate(['/loading'], {
            queryParams: {
              redirect: currentPath
            }
          });
        } else {
        }
      }
    });
}
